// Eskişehir district / mahalle landing pages — SEO-focused, minimal but rich.
// Used by AreaAkuDegisimi.jsx — driven by URL slug.

export const AREA_LANDINGS = {
  "tepebasi-aku-degisimi": {
    slug: "tepebasi-aku-degisimi",
    area: "Tepebaşı",
    title: "Tepebaşı Akü Değişimi | Eskişehir Yerinde Akü Servisi",
    description:
      "Eskişehir Tepebaşı bölgesinde yerinde akü değişimi. İnci Akü, Varta ve Bosch aküler. Aynı gün montaj, 6 ay ücretsiz yol yardımı, 2-3 yıl garanti.",
    heroLine:
      "Tepebaşı'nın tüm mahalle ve sokaklarına yerinde akü değişimi hizmeti.",
    intro:
      "Star Otogaz, Eskişehir Tepebaşı'nda 40 yılı aşkın tecrübesiyle akü satışı, montajı ve yerinde değişim hizmeti sunmaktadır. Tepebaşı'nda hangi noktada olursanız olun, uzman ekibimiz adresinize gelir; profesyonel ekipmanlarla akü değişiminizi gerçekleştirir.",
    neighbourhoods: [
      "Esentepe",
      "Şirintepe",
      "Hoşnudiye",
      "Çamlıca",
      "Yenibağlar",
      "Yeşiltepe",
      "Hisar",
      "Sütlüce",
    ],
  },
  "odunpazari-aku-degisimi": {
    slug: "odunpazari-aku-degisimi",
    area: "Odunpazarı",
    title: "Odunpazarı Akü Değişimi | Eskişehir Yerinde Akü Servisi",
    description:
      "Eskişehir Odunpazarı bölgesinde yerinde akü değişimi. İnci Akü, Varta ve Bosch aküler için aynı gün montaj, garantili akü hizmeti, 6 ay yol yardımı.",
    heroLine:
      "Odunpazarı ilçesi geneline yerinde akü değişimi ve test hizmeti.",
    intro:
      "Star Otogaz, Eskişehir Odunpazarı'nda araç sahiplerine yerinde akü değişimi ve elektrik sistemi kontrol hizmetleri sunmaktadır. Odunpazarı bölgesinde aracınız çalışmadığında WhatsApp üzerinden konumunuzu gönderin; ekibimiz hızla yola çıksın.",
    neighbourhoods: [
      "Akcami",
      "Paşa Mahallesi",
      "İstiklal",
      "Yenidoğan",
      "Karapınar",
      "75. Yıl",
      "Şarhöyük",
      "Cumhuriye",
    ],
  },
  "emek-mahallesi-aku-degisimi": {
    slug: "emek-mahallesi-aku-degisimi",
    area: "Emek Mahallesi",
    title: "Emek Mahallesi Akü Değişimi | Eskişehir Yerinde Akü Servisi",
    description:
      "Eskişehir Emek Mahallesi'nde yerinde akü değişimi. Star Otogaz ile İnci Akü, Varta ve Bosch aküler aynı gün adresinize teslim ve montaj.",
    heroLine:
      "Emek Mahallesi'nin tüm sokaklarına aynı gün yerinde akü değişimi.",
    intro:
      "Eskişehir Emek Mahallesi'nde aracınızın aküsü bittiğinde Star Otogaz uzman ekibi adresinize gelir. Yeni tarihli, garantili aküler — İnci Akü, Varta veya Bosch — profesyonel kontroller ve ölçümlerle takılır.",
    neighbourhoods: [
      "Emek Mahallesi 1. Cadde",
      "Emek 4. Sokak",
      "Atatürk Bulvarı",
      "Polatlı Caddesi çevresi",
    ],
  },
  "batikent-aku-degisimi": {
    slug: "batikent-aku-degisimi",
    area: "Batıkent",
    title: "Batıkent Akü Değişimi | Eskişehir Yerinde Akü Servisi",
    description:
      "Eskişehir Batıkent'te yerinde akü değişimi hizmeti. İnci Akü, Varta ve Bosch aküler için aynı gün montaj, garantili akü ve 6 ay yol yardımı.",
    heroLine: "Batıkent bölgesine yerinde akü değişimi ve test hizmeti.",
    intro:
      "Star Otogaz, Eskişehir Batıkent'te araç sahiplerine hızlı ve güvenli akü değişim hizmeti sunmaktadır. WhatsApp üzerinden konumunuzu paylaşın, ekibimiz Batıkent içerisindeki adresinize gelsin.",
    neighbourhoods: [
      "Batıkent Sitesi",
      "Batıkent Bulvarı",
      "Vişnelik çevresi",
      "Yıldıztepe",
    ],
  },
  "sazova-aku-degisimi": {
    slug: "sazova-aku-degisimi",
    area: "Sazova",
    title: "Sazova Akü Değişimi | Eskişehir Yerinde Akü Servisi",
    description:
      "Eskişehir Sazova bölgesinde yerinde akü değişimi. Star Otogaz ile İnci Akü, Varta ve Bosch aküler garantili olarak aynı gün montaj.",
    heroLine:
      "Sazova ve çevresine yerinde akü değişimi, elektrik kontrol hizmeti.",
    intro:
      "Eskişehir Sazova bölgesinde Star Otogaz ile yerinde akü değişimi mümkündür. Aracınız çalışmıyorsa veya akü performansından şüpheleniyorsanız, ekibimiz adresinize gelip ücretsiz test yapsın.",
    neighbourhoods: [
      "Sazova Parkı çevresi",
      "Çamlıca",
      "Şehit Ertuğrul Gazi",
      "Yıldıztepe",
    ],
  },
};
